import React, { useEffect, useState } from "react";
import { Card, CardBody, Table, Button, Input, Badge, } from "reactstrap";
import { toast } from "react-toastify";
import AppLoader from "../Common/AppLoader";
import { getPermissionsApi, deletePermissionApi } from "../../apiServices/permission.services";
import PermissionModal from "../PermissionsManager/PermissionModal";
import ConfirmModal from "../../Modal/Common/ConfirmModal";

const PermissionTable = () => {
  const [search, setSearch] = useState("");
  const [selectedPermission, setSelectedPermission] = useState(null);
  const [permissionModal, setPermissionModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deletePermissionId, setDeletePermissionId] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadPermissions = async () => {
    try {
      setLoading(true);

      const res = await getPermissionsApi({
        search,
      });

      setPermissions(res?.data || []);
    } catch (error) {
      toast.error(error?.message || "Failed to load permissions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(loadPermissions, 300);
    return () => clearTimeout(timer);
  }, [search]);

  const handleAdd = () => {
    setSelectedPermission(null);
    setPermissionModal(true);
  };

  const handleEdit = (permission) => {
    setSelectedPermission(permission);
    setPermissionModal(true);
  };

  const handleDelete = async () => {
    try {
        setDeleteLoading(true);

        const res = await deletePermissionApi(deletePermissionId);

        if (!res.success) {
        return toast.error(res.message);
        }

        toast.success("Permission deleted");

        setConfirmModal(false);
        setDeletePermissionId(null);

        loadPermissions();
    } catch (error) {
        toast.error(error?.message || "Failed to delete permission");
    } finally {
        setDeleteLoading(false);
    }
    };

  return (
    <>
      <Card>
        <CardBody>
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
            <h5 className="mb-0"> Permission Manager </h5>
            <Button color="primary" onClick={handleAdd} >
              <i className="mdi mdi-plus me-1" />
              Add Permission
            </Button>

          </div>

          <div className="mb-3">
            <Input
              value={search}
              placeholder="Search permission..."
              style={{ maxWidth: 320 }}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <div className="table-responsive">
            <Table hover className="align-middle" >
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Module</th>
                  <th>Name</th>
                  <th>Code</th>
                  <th>Status</th>
                  <th width={170}>Action</th>
                </tr>

              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="6" className="text-center py-5" >
                      <AppLoader compact />
                    </td>
                  </tr>
                ) : !permissions.length ? (
                  <tr>
                    <td colSpan="6" className="text-center" >
                      No Permissions Found
                    </td>
                  </tr>

                ) : (
                  permissions.map((item, index) => (
                    <tr key={item._id}>
                      <td>{index + 1}</td>
                      <td>{item.module}</td>
                      <td>{item.name}</td>
                      <td>
                        <code>{item.code}</code>
                      </td>
                      <td>
                        <Badge color={ item.isActive ? "success" : "danger" } >
                          {item.isActive ? "Active" : "Inactive"}
                        </Badge>
                      </td>
                      <td>
                        <div className="d-flex gap-2">
                          <Button
                            size="sm"
                            color="primary"
                            onClick={() => handleEdit(item) }
                          >
                            <i className="mdi mdi-pencil" />
                          </Button>
                          <Button
                            size="sm"
                            color="danger"
                            onClick={() => { setDeletePermissionId(item._id); setConfirmModal(true); }}
                          >
                            <i className="mdi mdi-delete" />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>

      <PermissionModal
        isOpen={permissionModal}
        permission={selectedPermission}
        toggle={() => {
          setPermissionModal(false);
          setSelectedPermission(null);
        }}
        onSuccess={loadPermissions}
      />
      <ConfirmModal
        isOpen={confirmModal}
        toggle={() => {
            if (deleteLoading) return;

            setConfirmModal(false);
            setDeletePermissionId(null);
        }}
        title="Delete Permission"
        message="Are you sure you want to delete this permission? This action can be restored later."
        confirmText="Delete"
        loading={deleteLoading}
        onConfirm={handleDelete}
        />

    </>
  );
};

export default PermissionTable;